import React from "react";

const TasksPartialPager = ({ currentPage, totalPages, onPageChange }) => {
    const maxVisiblePages = 10;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = startPage + maxVisiblePages - 1;

    if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
    }

    return (
        <tr>
            <td colSpan={9} style={{ textAlign: "center" }}>
                <nav>
                    <ul className="pagination justify-content-center mb-0">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => onPageChange(1)}>&laquo;</button>
                        </li>
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => onPageChange(currentPage - 1)}>Anterior</button>
                        </li>

                        {pages.map((page) => (
                            <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                                <button className="page-link" onClick={() => onPageChange(page)}>{page}</button>
                            </li>
                        ))}

                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => onPageChange(currentPage + 1)}>Siguiente</button>
                        </li>
                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button className="page-link" onClick={() => onPageChange(totalPages)}>&raquo;</button>
                        </li>
                    </ul>
                </nav>
            </td>
        </tr>
    );
};

export default TasksPartialPager;
